/*********************************************************************************************
* Initialize the sticky CTA behavior.
	* 
*/
function initializeStickyCTA() {
    const classicCTA = document.querySelector('[data-cta]');
    const sectionReassurance = document.querySelector('[data-reassurance]');

    if (!classicCTA || !sectionReassurance) {
        console.warn('Elements [data-cta] or [data-reassurance] not found!');
        return;
    }

    // Fonction de gestion du scroll
    function handleScroll() {
        const viewportBottom = window.innerHeight + window.scrollY; // Bas du viewport
        const reassuranceTop = sectionReassurance.getBoundingClientRect().top + window.scrollY; // Haut de data-reassurance

        // Si le bas du viewport touche ou dépasse le haut de data-reassurance
        if (viewportBottom >= reassuranceTop) {
            classicCTA.classList.add('mm-visible');
        } else {
            classicCTA.classList.remove('mm-visible');
        }
    }

    // Ajouter un listener pour surveiller le scroll
    window.addEventListener('scroll', handleScroll);
}

// Appeler la fonction
// initializeStickyCTA();



/*********************************************************************************************
* Initialize the Splide carousel for the main product slider.
	* 
*/
function mmSlideProduct() {
	var splideElemMain = document.querySelector("#main-slider");

	if (splideElemMain) {
		var main = new Splide(splideElemMain, {
			type: "slide",
			pagination: true,
			arrows: true,
			perPage: 1,
			breakpoints: {
				768: {
                    focus: 'center', 
                    speed: 400,
				},
			},
		});
		main.mount();
	}
}

/*********************************************************************************************
* Initialize the Splide carousel for the reassurance slider.
	* 
*/
function mmSlideProductReassurance() {
	var splideElemMain = document.querySelector("#slider-reassurance");

	if (splideElemMain) {
		var main = new Splide(splideElemMain, {
			type: "slide",
			rewind: true,
			pagination: true,
			arrows: false,
			autoplay: true,
			interval: 5000,
			perPage: 1,
		});
		main.mount();
	}
}

/*********************************************************************************************
* Change the quantity value in the input field and update the related prices.
	*
	* @param {number} delta - The change to apply to the current quantity (e.g., +1 or -1).
	* @param {string} inputId - The ID of the input field where the quantity is adjusted.
*/
function mmChangeQtty(delta, inputId) {
	let input = document.getElementById(inputId);
	const plusBtn = document.querySelector(`[data-qtty-plus="${inputId}"]`);

	if (delta === -1 && input.value === "1") {
		return;
	} else {
		var newValue = parseInt(input.value, 10) + parseInt(delta, 10);

		// Vérification si la nouvelle valeur atteint ou dépasse le maximum autorisé
		if (input.max && newValue >= parseInt(input.max, 10)) {
			newValue = parseInt(input.max, 10); // Limiter à la valeur maximale
			plusBtn.setAttribute("disabled", "true"); // Désactiver le bouton "+"
		} else {
			plusBtn.removeAttribute("disabled"); // Réactiver le bouton "+" si on est en dessous de la limite
		}

		// Mise à jour de la valeur de l'input
		input.value = newValue;

		// Mise à jour des prix en fonction de la nouvelle quantité
		mmUpdatePrice(newValue);
	}
}

/*********************************************************************************************
* Update the displayed prices based on the new quantity.
	*
	* @param {number} qtty - The current product quantity used to calculate the prices.
*/
function mmUpdatePrice(qtty) {
	var priceAll = document.querySelectorAll("[data-price]");
	var comparePriceAll = document.querySelectorAll("[data-compare-price]");

	// Fonction pour formater les prix
	function formatPrice(value) {
		// Convertit en euros (avec une virgule) et supprime les ",00" inutiles
		let formattedValue = (value / 100).toFixed(2).replace(".", ",");
		if (formattedValue.endsWith(",00")) {
			return formattedValue.slice(0, -3); // Supprime ",00"
		}
		return formattedValue;
	}

	// Met à jour les prix normaux
	priceAll.forEach(function (price) {
		var priceValue = parseFloat(price.dataset.price);
		if (!isNaN(priceValue)) {
			price.innerHTML = formatPrice(priceValue * qtty) + "€";
		} else {
			console.error("Valeur de prix non valide : ", price.dataset.price);
		}
	});

	// Met à jour les prix comparatifs
	comparePriceAll.forEach(function (comparePrice) {
		var comparePriceValue = parseFloat(comparePrice.dataset.comparePrice);
		if (!isNaN(comparePriceValue)) {
			comparePrice.innerHTML = formatPrice(comparePriceValue * qtty) + "€";
		} else {
			console.error("Valeur de prix comparatif non valide : ", comparePrice.dataset.comparePrice);
		}
	});
}

/*********************************************************************************************
* Class for handling variant selection
	* 
*/
class VariantSelector extends HTMLElement {
	constructor() {
		super();
		this.cached = {};
		this.container = this.closest("#product-form");
		this.addEventListener("change", this.onVariantChange);
	}

	/*********************************************************************************************
	* Handle variant change event.
		* 
	*/
	onVariantChange() {
		this.getSelectedOptions();
		this.getSelectedVariant();

		if (this.currentVariant) {
			this.updateURL();
			if (this.dataset.imageVariant) {
                this.updateImagesVariant();
            } else {
                this.updateMedia();
            }
            this.variantFetch();
		}
	}

	/*********************************************************************************************
	* Get selected options from the variant checkboxes.
		*
	*/
	getSelectedOptions() {
		this.options = Array.from(this.querySelectorAll(".mm-product-variant-checkbox:checked"), (checkbox) => checkbox.value);
	}

	/*********************************************************************************************
	* Get variant data from the embedded JSON.
		*
		* @returns {Object} - The variant data.
	*/
	getVariantJSON() {
		this.variantData = JSON.parse(this.querySelector('[type="application/json"]').textContent);
		return this.variantData;
	}

	/*********************************************************************************************
	* Get the selected variant based on selected options.
		*
	*/
	getSelectedVariant() {
		this.currentVariant = this.getVariantJSON().find((variant) => {
			const findings = !variant.options
				.map((option, index) => {
					return this.options[index] === option;
				})
				.includes(false);

			if (findings) return variant;
		});
	}

	/*********************************************************************************************
	* Update the URL to include the selected variant ID.
		*
	*/
	updateURL() {
		window.history.replaceState({}, "", `${this.dataset.url}?variant=${this.currentVariant.id}`);
	}

	/*********************************************************************************************
	* Fetch variant data from the server and cache it.
		*
	*/
	variantFetch() {
		var variantUrl = `${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.section}`;

		if (this.cached[variantUrl]) {
			this.renderVariantInfo(this.cached[variantUrl]);
			return;
		}

		fetch(variantUrl)
			.then((response) => response.text())
			.then((responseText) => {
				const html = new DOMParser().parseFromString(responseText, "text/html");
				this.cached[variantUrl] = html;
				this.renderVariantInfo(html);
			})
			.catch((e) => {
				console.error(e);
			});
	}

	/*********************************************************************************************
	* Render variant information in the DOM.
		*
		* @param {Document} html - The HTML document containing the variant information.
	*/
	renderVariantInfo(html) {
		this.updateElementOuter("#product_id", html);
		this.updateElementOuter(".mm-product-variants", html);
		this.updateElementOuter(".mm-pfc-quantity-cta", html);
		this.updateElementOuter(".mm-product-form-container-title-price-description", html);
		this.updateElementOuter(".mm-product-variant-gift-card-media", html);
		this.updateImagesVariant();
	}

	/*********************************************************************************************
	* Update the inner HTML of an element.
		*
		* @param {string} selector - The CSS selector of the element to update.
		* @param {HTMLElement} html - The HTML element containing the new content.
	*/
	updateElement(selector, html) {
		const destination = this.container.querySelector(selector);
		const source = html.querySelector(selector);
		if (source && destination) destination.innerHTML = source.innerHTML;
	}

	/*********************************************************************************************
	* Update the outer HTML of an element.
		*
		* @param {string} selector - The CSS selector of the element to update.
		* @param {HTMLElement} html - The HTML element containing the new content.
	*/
	updateElementOuter(selector, html) {
		const destination = this.container.querySelector(selector);
		const source = html.querySelector(selector);
		if (source && destination) destination.outerHTML = source.outerHTML;
	}

	/*********************************************************************************************
	* Update the media carousel to display the featured media of the current variant.
		*
		* This function searches for the corresponding media (image or video) of the selected variant 
		* and triggers the pagination button to update the media displayed in the main slider.
	*/
	updateMedia() {
        if (this.currentVariant.featured_media != null) {
            var allMainMedia = document.querySelectorAll(".mm-product-medias .splide__slide");
            var variant_media_id = this.currentVariant.featured_media.id;
            allMainMedia.forEach((media) => {
                if (media.dataset.id != null && parseInt(media.dataset.id) == variant_media_id) {
                    var pagination = document.querySelectorAll(".mm-product-medias .splide__pagination li")[parseInt(media.dataset.index)];
                    pagination.querySelector("button").click();
                }
            });
        }
    }

	/*********************************************************************************************
	* Update the visibility of the media sliders for the current variant.
		*
		* This function shows the correct media slider for the selected variant while hiding the others.
		* It manages both the main product media slider and the thumbnail slider.
	*/
	updateImagesVariant() {
        var allMainMedia = document.querySelectorAll(".main-slider-variant");
        allMainMedia.forEach((media) => {
            if (media.dataset.variantid == this.currentVariant.id) {
                media.style.display = "flex";
            } else {
                media.style.display = "none";
            }
        });
        var allThumbnailMedia = document.querySelectorAll(".thumbnail-slider-variant");
        allThumbnailMedia.forEach((media) => {
            if (media.dataset.variantid == this.currentVariant.id) {
                media.style.display = "flex";
            } else {
                media.style.display = "none";
            }
        });
    }
}

/*********************************************************************************************
* Define the custom element
	*
*/
customElements.define("variant-selector", VariantSelector);

/*********************************************************************************************
* Loaded Listenner
	*
*/
document.addEventListener("DOMContentLoaded", () => {
	mmSlideProduct();
	mmSlideProductReassurance();
	initializeStickyCTA();
});

/*********************************************************************************************
* Read-more x Read-less
	*
*/
document.addEventListener('DOMContentLoaded', function () {
    const containerDiv = document.querySelector('.mm-pfc-description');
    const readMoreBtn = document.getElementById('read-less');
    const descriptionDiv = document.querySelector('.mm-description');

    // Récupérer les valeurs depuis les data-* attributes du conteneur
    const seeMoreText = containerDiv.dataset.seeMore;
    const seeLessText = containerDiv.dataset.seeLess;
    const seeCondition = containerDiv.dataset.title; // "mm-see-flex" ou "mm-see-none"

    // Fonction pour ajuster la hauteur maximale en fonction de la largeur de l'écran
    function adjustMaxHeight() {
        if (window.matchMedia('(min-width: 768px)').matches) {
			return '4rem';
        } else {
            return '6rem';
        }
    }

    // Logique d'affichage et d'application de la classe en fonction de "seeCondition"
    if (seeCondition === 'Carte cadeau') {
        readMoreBtn.style.display = 'none'; // Masquer le bouton
        descriptionDiv.classList.remove('mm-read-more-true'); // Retirer la classe
    } else if (seeCondition !== 'Carte cadeau') {
        readMoreBtn.style.display = 'inline'; // Afficher le bouton
        descriptionDiv.classList.add('mm-read-more-true'); // Ajouter la classe par défaut
        descriptionDiv.style.maxHeight = adjustMaxHeight(); // Hauteur initiale adaptée
    }

    // Ajouter un événement de clic au bouton
    readMoreBtn.addEventListener('click', function () {
        if (descriptionDiv.classList.contains('mm-read-more-true')) {
            // Ouverture
            descriptionDiv.classList.remove('mm-read-more-true');
            descriptionDiv.classList.add('expanded');
            readMoreBtn.innerText = seeLessText;

            // Appliquer la hauteur réelle pour ouverture fluide
            const expandedHeight = descriptionDiv.scrollHeight;
            descriptionDiv.style.maxHeight = expandedHeight + 'px';

            // Retirer la limite après la transition pour adapter dynamiquement
            setTimeout(() => {
                descriptionDiv.style.maxHeight = 'none';
            }, 900); // Durée de la transition
        } else {
            // Fermeture
            descriptionDiv.style.maxHeight = descriptionDiv.scrollHeight + 'px'; // Fixer la hauteur actuelle
            descriptionDiv.classList.remove('expanded');

            // Forcer un recalcul du style pour garantir la transition
            requestAnimationFrame(() => {
                descriptionDiv.style.maxHeight = adjustMaxHeight(); // Hauteur réduite adaptée
            });

            // Une fois la transition terminée, appliquer les propriétés de troncature
            setTimeout(() => {
                descriptionDiv.classList.add('mm-read-more-true');
            }, 900); // Durée de la transition
            readMoreBtn.innerText = seeMoreText;
        }
    });

    // Si la fenêtre est redimensionnée, ajuster la hauteur
    window.addEventListener('resize', function () {
        if (seeCondition !== 'Carte cadeau') {
            descriptionDiv.style.maxHeight = adjustMaxHeight();
            readMoreBtn.style.display = 'inline';
        }
    });
});



/*********************************************************************************************
* Splide reassurance
	*
*/
document.addEventListener('DOMContentLoaded', function() {
	var splideElem = document.querySelector('.splide-reassurance[data-section-id]');

	// Récupération de l'attribut data-interval, avec une valeur par défaut si non défini
	var interval = parseInt(splideElem.dataset.interval) || 5000;

	new Splide(splideElem, {
		type        : 'loop',
		arrows      : false,
		pagination  : true,
		perPage     : 1,
		drag        : 'free',
		snap        : true,
		gap         : '6px',
		autoplay    : true,
		interval    : interval, // Utilisation de la valeur récupérée
		pauseOnHover: false,
		breakpoints : {
			768: {
			}
		}
	}).mount();    
});

/*********************************************************************************************
* Splide additionnal product
	*
*/
document.addEventListener('DOMContentLoaded', function() {
	var splideElem = document.querySelector('.splide-additionnal-product[data-section-id]');
	
	new Splide(splideElem, {
		type   : 'slide',
		arrows : false,
		pagination: true,
		perPage: 1,
		drag   : 'free',
		fixedWidth: 380,
		snap   : true,	
		speed	: 1000,
		gap    : '16px',
		breakpoints : {
			768: {
				fixedWidth: '75vw',
			}
		}
	}).mount();    
});

/*********************************************************************************************
* Splide Media
	*
*/
document.addEventListener('DOMContentLoaded', function() {
	var splideElemMain = document.querySelector('#main-slider');
	var splideElemThumbnails = document.querySelector('#thumbnail-slider');
	
	function updateThumbnailHeight() {
		thumbnails.options.height = document.querySelector('.mm-product-medias-slider').offsetHeight;
		thumbnails.refresh();
	}

	var main = new Splide(splideElemMain, {
		type: 'slide',
		speed: 800,
		rewind: true,
		perPage: 1,
		pagination: true,
		arrows: false,
		breakpoints: {
			1024: {
				focus: 'center'
			}
		}
	});

	var thumbnails = new Splide(splideElemThumbnails, {
		type: 'slide',
		perPage: 1,
		height: '200px',
		direction: 'ttb',
		isNavigation: true,
		pagination: true,
		arrows: false,
	});

	main.sync(thumbnails);
	main.mount();
	thumbnails.mount();

	updateThumbnailHeight();

	window.addEventListener('resize', updateThumbnailHeight);
});


/*********************************************************************************************
* Kalvio back in stock
	*
*/
document.addEventListener("DOMContentLoaded", function () {
    var ticking = false; // Variable pour limiter les appels fréquents

    // Fonction pour synchroniser les positions et la largeur des éléments
    function synchronizePositions() {
        var element = document.querySelector(".mm-pfc-quantity-cta");
        var productWrapper = document.querySelector(".mm-product-form");

        if (!element || !productWrapper) {
            console.log("Élément ou productWrapper non trouvé.");
            return;
        }

        var rect = element.getBoundingClientRect();
        var topPosition = rect.top + window.scrollY;
        var productWrapperWidth = productWrapper.getBoundingClientRect().width;

        var iframeElement = document.getElementById("klaviyo-bis-iframe");
        if (!iframeElement) {
            console.log("Élément klaviyo-bis-iframe non trouvé.");
            return;
        }

        // Positionnement et dimensionnement de l'iframe
        iframeElement.style.position = "absolute";
        iframeElement.style.top = topPosition + "px";
        iframeElement.style.width = "100%";
        iframeElement.style.height = "fit-content";

        // Charger immédiatement la largeur du container dans l'iframe
        var iframeDocument = iframeElement.contentWindow.document;
        iframeElement.onload = function () {
            var containerElement = iframeDocument.getElementById("container");

            if (containerElement) {
                // Applique immédiatement la largeur du parent pour éviter les glitches
                containerElement.style.width = productWrapperWidth + "px";
            } else {
                console.log("Élément #container non trouvé dans l'iframe.");
            }
        };

        // Si l'iframe est déjà chargée, exécuter immédiatement
        if (iframeElement.contentWindow.document.readyState === 'complete') {
            iframeElement.onload();
        }
    }

    // Fonction pour fermer l'élément
    function closeElement() {
        var iframeElement = document.getElementById("klaviyo-bis-iframe");
        if (iframeElement) {
            iframeElement.style.display = "none"; // Cacher l'iframe ou fermer l'élément
        }
    }

    // Fonction wrapper pour utiliser requestAnimationFrame
    function requestTick() {
        if (!ticking) {
            requestAnimationFrame(function () {
                synchronizePositions();
                ticking = false; // Réinitialise après l'exécution
            });
            ticking = true;
        }
    }

    // Synchroniser les positions et la largeur au chargement initial de la page
    synchronizePositions();

    // Ajout d'un écouteur d'événements de clic sur l'élément klaviyo-bis-trigger
    var triggerElement = document.querySelector(".klaviyo-bis-trigger");
    if (triggerElement) {
        triggerElement.addEventListener("click", function () {
            var iframeElement = document.getElementById("klaviyo-bis-iframe");
            iframeElement.style.display = "block"; // Afficher l'iframe au clic
            synchronizePositions();
        });
    }

    // Fermer l'élément lorsque l'utilisateur clique en dehors de #container
    document.addEventListener("click", function (event) {
        var iframeElement = document.getElementById("klaviyo-bis-iframe");
        var triggerElement = document.querySelector(".klaviyo-bis-trigger");

        if (iframeElement) {
            var iframeDocument = iframeElement.contentWindow.document;
            var containerElement = iframeDocument.getElementById("container");

            // Vérifie si le clic est à l'extérieur de l'iframe, du bouton trigger, et de #container
            if (triggerElement) {
              if (
                  !iframeElement.contains(event.target) && 
                  !triggerElement.contains(event.target) && 
                  (!containerElement || !containerElement.contains(event.target))
              ) {
                  closeElement();
              }            
            }
        }
    });

    // Ajout du scroll listener pour fermer l'iframe lors du défilement
    document.addEventListener("scroll", function () {
        var iframeElement = document.getElementById("klaviyo-bis-iframe");
        if (iframeElement && window.getComputedStyle(iframeElement).display !== "none") {
            iframeElement.style.display = "none"; // Fermer l'iframe au défilement
        }
    });

    // Synchroniser les positions lors du redimensionnement et du défilement de la fenêtre
    window.addEventListener("resize", requestTick);
    window.addEventListener("scroll", requestTick);
});